import {
  GET_SERVICE_OFFERED,
  GET_SERVICE_OFFERED_FAILURE,
  GET_SERVICE_OFFERED_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getServiceOfferedReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICE_OFFERED:
      return { ...state, loading: true };
    case GET_SERVICE_OFFERED_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_SERVICE_OFFERED_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getServiceOfferedReducer;
